import { createAction, createSlice } from "@reduxjs/toolkit";
import { caseComparisonResponse } from "../../model/jetlift/jetlift";

interface JetliftComparisonState {
    comparisonData1: caseComparisonResponse | null;
    comparisonData2: caseComparisonResponse | null;
    comparisonData3: caseComparisonResponse | null;
    compareInput1: string;
    compareInput2: string;
    compareInput3: string;
    persistedCase1: string;
    persistedCase2: string;
    persistedCase3: string;
}

export const initialState: JetliftComparisonState = {
    comparisonData1: null,
    comparisonData2: null,
    comparisonData3: null,
    persistedCase1: "",
    persistedCase2: "",
    persistedCase3: "",
    compareInput1: "",
    compareInput2: "",
    compareInput3: "",
};

export const getJetliftComparisonData = createAction("jetlift/comparison/getJetliftComparisonData");

const JetliftComparisonSlice = createSlice({
    name: 'jetlift/comparison',
    initialState,
    reducers: {
        setComparisonData1(state, action) {
            state.comparisonData1 = action.payload;
        },
        setComparisonData2: (state, action) => {
            state.comparisonData2 = action.payload;
        },
        setComparisonData3: (state, action) => {
            state.comparisonData3 = action.payload;
        },
        setComparisonInput1(state, action) {
            state.compareInput1 = action.payload !== "00000000-0000-0000-0000-000000000000" ? action.payload : state.compareInput1;
        },
        setComparisonInput2: (state, action) => {
            state.compareInput2 = action.payload;
        },
        setComparisonInput3: (state, action) => {
            state.compareInput3 = action.payload;
        },
        setPersistedCase1(state, action) {
            state.persistedCase1 = action.payload;
        },
        setPersistedCase2: (state, action) => {
            state.persistedCase2 = action.payload;
        },
        setPersistedCase3: (state, action) => {
            state.persistedCase3 = action.payload;
        },
    }
});

export const {
    setComparisonData1,
    setComparisonData2,
    setComparisonData3,
    setComparisonInput1,
    setComparisonInput2,
    setComparisonInput3,
    setPersistedCase1,
    setPersistedCase2,
    setPersistedCase3,
} = JetliftComparisonSlice?.actions;

export default JetliftComparisonSlice.reducer;